import { render, staticRenderFns } from "./SlotEdit.vue?vue&type=template&id=c38a664a&scoped=true&lang=pug"
import script from "./SlotEdit.vue?vue&type=script&lang=ts"
export * from "./SlotEdit.vue?vue&type=script&lang=ts"
import style0 from "./SlotEdit.vue?vue&type=style&index=0&id=c38a664a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38a664a",
  null
  
)

export default component.exports